export default [
  {
    path: '/404',
    meta: {
      public: true,
    },
    name: 'NotFound',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/NotFound.vue`
    )
  },
  {
    path: '/403',
    meta: {
      public: true,
    },
    name: 'AccessDenied',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Deny.vue`
    )
  },
  {
    path: '/500',
    meta: {
      public: true,
    },
    name: 'ServerError',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Error.vue`
    )
  },
  {
    path: '/',
    meta: { roleId: 1 },
    name: 'Root',
    redirect: {
      name: 'Profile'
    }
  },
  {
    path: '/login',
    meta: {
      public: true,
    },
    name: 'Login',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Login.vue`
    )
  },
  {
    path: '/profile',
    meta: { breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 1 },
    name: 'Profile',
    component: () => import(
      `@/views/Profile.vue`
    )
  },
  {
    path: '/notifications/',
    meta: { title: 'Thông báo', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 1 },
    name: 'NotificationList',
    component: () => import(
      `@/views/Notification/list.vue`
    )
  },
  {
    path: '/logging/',
    meta: { title: 'Nhật ký hệ thống', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 1, permissionKey: 'logging' },
    name: 'SystemLogList',
    component: () => import(
      `@/views/SystemLog/list.vue`
    )
  },
  {
    path: '/khach-hang/',
    meta: { title: 'Khách hàng', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 4, permissionKey: 'customer' },
    name: 'CustomerList',
    component: () => import(
      `@/views/Customer/list.vue`
    )
  },
  {
    path: '/khach-hang/:Pid',
    meta: { title: 'Khách hàng', breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 4, permissionKey: 'customer' },
    name: 'CustomerDetail',
    component: () => import(
      `@/views/Customer/detail.vue`
    )
  },
  {
    path: '/thanh-toan/cho-thanh-toan/',
    meta: { title: 'Danh sách chờ thanh toán', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 1, permissionKey: 'payment_pending' },
    name: 'PaymentPendingList',
    component: () => import(
      `@/views/Payment/pending.vue`
    )
  },
  {
    path: '/thanh-toan/lich-su/',
    meta: { title: 'Lịch sử thanh toán', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 1, permissionKey: 'payment_history' },
    name: 'PaymentHistoryList',
    component: () => import(
      `@/views/Payment/history.vue`
    )
  },
  // {
  //   path: '/thanh-toan-don-hang/',
  //   meta: { breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 8 },
  //   name: 'PayOrderList',
  //   component: () => import(
  //     `@/views/PayOrder/list.vue`
  //   )
  // },
  // {
  //   path: '/lich-su-thanh-toan/',
  //   meta: { breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 16 },
  //   name: 'PayHistoryList',
  //   component: () => import(
  //     `@/views/PaymentHistory/PaymentHistoryList.vue`
  //   )
  // },
  // {
  //   path: '/lich-su-nap-tien/',
  //   meta: { breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 512 },
  //   name: 'RechargeHistory',
  //   component: () => import(
  //     `@/views/RechargeHistory/detail.vue`
  //   )
  // },
  // {
  //   path: '/bao-cao/nap-tien/',
  //   meta: { title: 'Báo cáo nạp tiền', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 1024 },
  //   name: 'bao-cao-nap-tien',
  //   component: () => import(
  //     `@/views/Reports/bao-cao-nap-tien.vue`
  //   )
  // },
  {
    path: '/hang-tmdt/bao-cao-bao-hang/',
    meta: { title: 'Báo cáo bao hàng', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 2, permissionKey: 'bao_cao_bao_hang' },
    name: 'bao-cao-bao-hang',
    component: () => import(
      `@/views/Reports/bao-cao-bao-hang.vue`
    )
  },
  {
    path: '/hang-tmdt/bao-cao-xuat-hang/',
    meta: { title: 'Báo cáo xuất hàng', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 2, permissionKey: 'bao_cao_xuat_hang' },
    name: 'bao-cao-xuat-hang',
    component: () => import(
      `@/views/Reports/bao-cao-xuat-hang.vue`
    )
  },
  {
    path: '/hang-tmdt/ma-van-don/',
    meta: { title: 'Mã vận đơn', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 32, permissionKey: 'small_package' },
    name: 'SmallPackage',
    component: () => import(
      `@/views/Tracking/list.vue`
    )
  },
  {
    path: '/tracking/',
    meta: { breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 2048 },
    name: 'Tracking',
    component: () => import(
      `@/views/Tracking/tracking.vue`
    )
  },
  {
    path: '/hang-tmdt/nhap-kho-tq/',
    meta: { title: 'Nhập kho TQ', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 8, permissionKey: 'store_cn' },
    name: 'StoreManager',
    component: () => import(
      `@/views/StoreManager/list.vue`
    )
  },
  {
    path: '/hang-tmdt/nhap-kho-vn/',
    meta: { title: 'Nhập kho VN', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 16, permissionKey: 'store_vn' },
    name: 'StoreManagerVN',
    component: () => import(
      `@/views/StoreManagerVN/list.vue`
    )
  },
  {
    path: '/hang-tmdt/khong-ten/',
    meta: { breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 32, permissionKey: 'noname' },
    name: 'Noname',
    component: () => import(
      `@/views/Noname/list.vue`
    )
  },
  {
    path: '/hang-tmdt/yeu-cau-xuat-kho/',
    meta: { title: 'Yêu cầu xuất kho', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 128, permissionKey: 'export_receipt' },
    name: 'ExportReceipt',
    component: () => import(
      `@/views/ExportReceipt/list.vue`
    )
  },
  {
    path: '/hang-tmdt/quan-ly-bao-hang/',
    meta: { title: 'Bao hàng', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 64, permissionKey: 'big_package' },
    name: 'BigPackage',
    component: () => import(
      `@/views/BigPackage/list.vue`
    )
  },
  {
    path: '/cai-dat/phi-can-nang/',
    meta: { title: 'Phí cân nặng', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 256, permissionKey: 'setting' },
    name: 'FeeWeightList',
    component: () => import(
      `@/views/FeeWeight/list.vue`
    )
  },
  {
    path: '/cai-dat/phi-khoi/',
    meta: { title: 'Phí khối', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 256, permissionKey: 'setting' },
    name: 'FeeVolumeList',
    component: () => import(
      `@/views/FeeVolume/list.vue`
    )
  },
  {
    path: '/cai-dat/cau-hinh-chung',
    meta: { breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 256, permissionKey: 'setting' },
    name: 'Configuration',
    component: () => import(
      `@/views/Configuration/detail.vue`
    )
  },
  {
    path: '/cai-dat/nhan-vien/',
    meta: { breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 256, permissionKey: 'setting' },
    name: 'StaffList',
    component: () => import(
      `@/views/Staff/list.vue`
    )
  },
  {
    path: '/cai-dat/nhan-vien/:Pid',
    meta: { breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 256, permissionKey: 'setting' },
    name: 'StaffDetail',
    component: () => import(
      `@/views/Staff/detail.vue`
    )
  },
  {
    path: '/cai-dat/kho-nhan/',
    meta: { title: 'Kho nhận', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 256, permissionKey: 'setting' },
    name: 'StorageList',
    component: () => import(
      `@/views/Storage/list.vue`
    )
  },
  {
    path: '/cai-dat/phan-quyen/',
    meta: { title: 'Phân quyền', breadcrumb: true, requiresAuth: true, createButton: false, refreshButton: true, roleId: 1, permissionKey: 'setting' },
    name: 'PermissionMatrix',
    component: () => import(
      `@/views/Permission/PermissionMatrix.vue`
    )
  },
  {
    path: '/cai-dat/loai-hang/',
    meta: { title: 'Loại hàng', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 256, permissionKey: 'setting' },
    name: 'ProductTypeList',
    component: () => import(
      `@/views/ProductType/list.vue`
    )
  },
  {
    path: '/nhat-ky-thao-tac/',
    meta: { title: 'Nhật ký thao tác', titleKey: 'routes.audit_log', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 256, permissionKey: 'setting' },
    name: 'AuditLogList',
    component: () => import(
      `@/views/AuditLog/list.vue`
    )
  },
  {
    path: '/hang-lo/hang-khong-ten/',
    meta: { title: 'Hàng không tên', package_status: [], breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, importButton: true, roleId: 32, permissionKey: 'unnamed_package' },
    name: 'UnnamedPackage',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/hang-lo/quan-ly-ma-boc/',
    meta: { title: 'Quản lý mã bốc', package_status: [], breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, importButton: true, roleId: 32, permissionKey: 'batch_package_all' },
    name: 'BatchPackageAll',
    component: () => import(
      `@/views/Product/list.vue`
    )
  },
  {
    path: '/hang-lo/quan-ly-ma-boc/:Pid',
    meta: { title: 'Chi tiết mã bốc', breadcrumb: true, requiresAuth: true, saveButton: true, refreshButton: true, roleId: 32, permissionKey: 'batch_package_all' },
    name: 'ProductDetail',
    component: () => import(
      `@/views/Product/detail.vue`
    )
  },
  {
    path: '/hang-lo/xep-xe/',
    meta: { title: 'Quản lý Xe', breadcrumb: true, requiresAuth: true, createButton: true, exportButton: true, refreshButton: true, roleId: 32, permissionKey: 'truck_list' },
    name: 'TruckList',
    component: () => import(
      `@/views/Truck/list.vue`
    )
  },
  {
    path: '/hang-lo/xep-xe/:Pid',
    meta: { title: 'Quản lý Xe', breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 32, permissionKey: 'truck_list' },
    name: 'TruckDetail',
    component: () => import(
      `@/views/Truck/detail.vue`
    )
  },
  {
    path: '/hang-lo/xuat-kho/',
    meta: { title: 'Xuất kho', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 32, permissionKey: 'bill_list' },
    name: 'BillList',
    component: () => import(
      `@/views/Bill/list.vue`
    )
  },
  {
    path: '/hang-lo/xuat-kho/:Pid',
    meta: { title: 'Xuất kho', breadcrumb: true, requiresAuth: true, saveButton: true, createButton: true, createButtonText: 'Xuất kho', createButtonIcon: 'check', roleId: 32, permissionKey: 'bill_list' },
    name: 'BillDetail',
    component: () => import(
      `@/views/Bill/detail.vue`
    )
  },
  {
    path: '/hang-lo/bc-chung/',
    meta: { title: 'Bảng thông tin chung', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 32, permissionKey: 'sales_dashboard' },
    name: 'SalesDashboard',
    component: () => import(
      `@/views/Reports/dashboard.vue`
    )
  },
  {
    path: '/hang-lo/bao-cao-luu-kho/',
    meta: { title: 'Báo cáo lưu kho', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 32, permissionKey: 'storage_by_batch_code_report' },
    name: 'StorageByBatchCodeReport',
    component: () => import(
      `@/views/Reports/bao-cao-luu-kho.vue`
    )
  },
  {
    path: '/hang-tmdt/bc-chung/',
    meta: { title: 'Bảng thông tin TMĐT', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 32, permissionKey: 'tmdt_sales_dashboard' },
    name: 'TmdtSalesDashboard',
    component: () => import(
      `@/views/Reports/tmdt-dashboard.vue`
    )
  },
  {
    path: '/hang-lo/nhap-kho-tq/',
    meta: { title: 'Nhập kho TQ', breadcrumb: true, requiresAuth: true, createButton: false, refreshButton: true, importButton: true, roleId: 32, permissionKey: 'wuliu_list' },
    name: 'WuliuList',
    component: () => import(
      `@/views/Wuliu/list.vue`
    )
  },
  // ===== Hàng Chính Ngạch =====
  {
    path: '/cai-dat/thiet-lap-dich-vu/',
    meta: { title: 'Thiết lập dịch vụ CN', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 1, permissionKey: 'cn_service' },
    name: 'CnServiceList',
    component: () => import(
      `@/views/CnService/list.vue`
    )
  },
  {
    path: '/hang-chinh-ngach/don-hang/',
    meta: { title: 'Quản lý đơn hàng CN', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 1, permissionKey: 'cn_order' },
    name: 'CnOrderList',
    component: () => import(
      `@/views/CnOrder/list.vue`
    )
  },
  {
    path: '/hang-chinh-ngach/don-hang/:Pid',
    meta: { title: 'Chi tiết đơn hàng CN', breadcrumb: true, requiresAuth: true, saveButton: true, refreshButton: true, roleId: 1, permissionKey: 'cn_order' },
    name: 'CnOrderDetail',
    component: () => import(
      `@/views/CnOrder/detail.vue`
    )
  },
  {
    path: '/hang-chinh-ngach/hang-hoa/',
    meta: { title: 'Hàng hóa CN', breadcrumb: true, requiresAuth: true, refreshButton: true, importButton: true, roleId: 1, permissionKey: 'cn_order' },
    name: 'CnProductList',
    component: () => import(
      `@/views/CnOrderProduct/list.vue`
    )
  },
  {
    path: '/hang-chinh-ngach/ma-van-don/',
    meta: { title: 'Mã vận đơn CN', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 1, permissionKey: 'cn_order' },
    name: 'CnWaybillList',
    component: () => import(
      `@/views/CnWaybill/list.vue`
    )
  },
  {
    path: '/hang-chinh-ngach/xep-xe/',
    meta: { title: 'Quản lý khai báo / 报关管理', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 1, permissionKey: 'cn_truck' },
    name: 'CnTruckList',
    component: () => import(
      `@/views/CnTruck/list.vue`
    )
  },
  {
    path: '/hang-chinh-ngach/xep-xe/:Pid',
    meta: { title: 'Chi tiết khai báo', breadcrumb: true, requiresAuth: true, saveButton: true, refreshButton: true, roleId: 1, permissionKey: 'cn_truck' },
    name: 'CnTruckDetail',
    component: () => import(
      `@/views/CnTruck/detail.vue`
    )
  },
  {
    path: '/hang-chinh-ngach/giao-hang/',
    meta: { title: 'Giao hàng CN', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 1, permissionKey: 'cn_delivery' },
    name: 'CnDeliveryList',
    component: () => import(
      `@/views/CnDelivery/list.vue`
    )
  },
  {
    path: '/hang-chinh-ngach/giao-hang/:Pid',
    meta: { title: 'Chi tiết lệnh giao hàng CN', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 1, permissionKey: 'cn_delivery' },
    name: 'CnDeliveryDetail',
    component: () => import(
      `@/views/CnDelivery/detail.vue`
    )
  },
  {
    path: '/hang-chinh-ngach/payment-cn/',
    meta: { title: 'Quản lý tài chính / 财务管理', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 1, permissionKey: 'cn_payment' },
    name: 'CnPaymentList',
    component: () => import(
      `@/views/CnPayment/list.vue`
    )
  },
  {
    path: '/hang-chinh-ngach/bao-cao/',
    meta: { title: 'Bảng thông tin CN', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 1, permissionKey: 'cn_report' },
    name: 'CnSalesDashboard',
    component: () => import(
      `@/views/Reports/cn-dashboard.vue`
    )
  }
];
